
interface Held {
  fingerprint: string;
  key: string;
}

const held = new Map<string, Held>();

function newKey(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
  }
  return `k-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

export function idempotencyKeyFor(scope: string, fingerprint: string): string {
  const cur = held.get(scope);
  if (cur && cur.fingerprint === fingerprint) return cur.key;
  const next = { fingerprint, key: newKey() };
  held.set(scope, next);
  return next.key;
}

export function releaseIdempotencyKey(scope: string): void {
  held.delete(scope);
}

export async function withIdempotencyKey<T>(
  scope: string,
  body: unknown,
  run: (key: string) => Promise<T>,
): Promise<T> {
  const key = idempotencyKeyFor(scope, JSON.stringify(body ?? null));
  const res = await run(key);
  releaseIdempotencyKey(scope);
  return res;
}

export function resetIdempotencyKeys(): void {
  held.clear();
}
